import React, { FC } from 'react'

interface RequiredTagProps {
  required: boolean
}

export const RequiredTag: FC<RequiredTagProps> = ({ required }) => {
  const bg = required ? 'bg-main-red' : 'bg-main-darkgray'
  const text = required ? '必須' : '任意'

  return (
    <div className="flex flex-col justify-center">
      <div className={`rounded-md ${bg} w-fit h-fit`}>
        <p className="text-white text-xs text-center px-2">{text}</p>
      </div>
    </div>
  )
}
